/* HENA.AX — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al entrar en pantalla */
  function initReveal() {
    var els = document.querySelectorAll('.hx-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Manifiesto: las palabras se encienden al avanzar el scroll */
  function initManifiesto() {
    document.querySelectorAll('[data-hx-manifiesto]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var text = el.textContent.trim().replace(/\s+/g, ' ');
      el.setAttribute('aria-label', text);
      el.innerHTML = text.split(' ').map(function (w) { return '<span class="hx-w" aria-hidden="true">' + w + '</span>'; }).join(' ');
      var words = el.querySelectorAll('.hx-w');
      if (reduce || (window.Shopify && Shopify.designMode)) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
      function update() {
        var r = el.getBoundingClientRect(), vh = window.innerHeight || 800;
        var start = vh * 0.85, end = vh * 0.25;
        var p = (start - r.top) / (start - end + r.height * 0.6);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Anuncios que rotan */
  function initAnuncios() {
    document.querySelectorAll('[data-hx-rotar]').forEach(function (box) {
      var items = box.querySelectorAll('[data-hx-item]');
      if (items.length < 2) return;
      var i = 0, ms = (parseFloat(box.dataset.hxRotar) || 5) * 1000;
      items.forEach(function (it, k) { it.hidden = k !== 0; });
      setInterval(function () {
        items[i].hidden = true; i = (i + 1) % items.length; items[i].hidden = false;
      }, ms);
    });
  }

  /* Videos: se reproducen en silencio cuando entran en pantalla */
  function initVideos() {
    var marcos = document.querySelectorAll('[data-hx-video]');
    if (!marcos.length) return;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target.querySelector('video'); if (!v) return;
        if (en.isIntersecting && en.intersectionRatio >= 0.55 && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: [0, 0.55, 1] }) : null;
    marcos.forEach(function (m) {
      if (m.dataset.listo) return; m.dataset.listo = '1';
      var v = m.querySelector('video'); if (!v) return;
      v.muted = true; v.setAttribute('playsinline', '');
      v.addEventListener('error', function () { var hd = v.getAttribute('data-hd'); if (hd && v.getAttribute('src') !== hd) { v.setAttribute('src', hd); v.load(); } });
      if (io) io.observe(m);
      var btn = m.querySelector('[data-hx-sonido]');
      if (btn) btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var on = v.muted;
        marcos.forEach(function (o) { var ov = o.querySelector('video'); if (ov && o !== m) { ov.muted = true; o.classList.remove('is-sonido'); } });
        v.muted = !on; m.classList.toggle('is-sonido', on);
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      m.addEventListener('click', function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
    });
  }

  /* Barra fija de compra en la ficha de producto */
  function initSticky() {
    var bar = document.querySelector('[data-hx-sticky]'); if (!bar || bar.dataset.listo) return;
    var principal = document.querySelector('.product__info-container .product-form__submit');
    if (!principal) return;
    bar.dataset.listo = '1'; bar.hidden = false;
    var btn = bar.querySelector('[data-hx-sticky-btn]');
    var opciones = document.querySelector('.product__info-container variant-selects, .product__info-container variant-radios, .product__info-container .product-form__input');
    var visible = false;
    function mostrar(s) { if (s === visible) return; visible = s; bar.classList.toggle('is-visible', s); bar.setAttribute('aria-hidden', s ? 'false' : 'true'); }
    var tick = false;
    function revisar() { tick = false; mostrar(principal.getBoundingClientRect().bottom < 0); }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(revisar); } }, { passive: true });
    window.addEventListener('resize', revisar);
    revisar();
    btn.addEventListener('click', function () {
      var hayOpciones = opciones && !document.querySelector('.hx-sticky__boton').textContent.match(/Agregar/i);
      if (hayOpciones) { opciones.scrollIntoView({ behavior: 'smooth', block: 'center' }); } else { principal.click(); }
    });
  }

  function init() { initReveal(); initManifiesto(); initAnuncios(); initVideos(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
